import { defineStore, storeToRefs } from 'pinia';
import { useTransactionListFilterStore } from '@/store/transaction/transaction-list-filter.store';
import { clearObj, downloadFile } from '@marfa/bo-utils';
import { api } from '@/services/http.service';
import { useTransactionListStore } from '@/store/transaction/transaction-list.store';
import { DEFAULT_REPORT_LIMIT } from '@/models/constants';
import { showErrorNotification } from '@/utils/show-notification.util';

type TransactionListReportStore = {
  isTransactionListReportLoading: boolean;
}

export const useTransactionListReportStore = defineStore({
  id: 'TransactionListReportStore',
  state: (): TransactionListReportStore => ({
    isTransactionListReportLoading: false,
  }),
  actions: {
    setTransactionListReportLoading(isLoading: boolean): void {
      this.isTransactionListReportLoading = isLoading;
    },
    getTransactionListReport(wlSlug: string): Promise<void> {
      this.setTransactionListReportLoading(true);

      const { submittedFilterFormData } = storeToRefs(useTransactionListFilterStore());
      const { sort } = storeToRefs(useTransactionListStore());

      const requestPayload = {
        limit: DEFAULT_REPORT_LIMIT,
        filterList: clearObj(submittedFilterFormData.value),
        sort: sort.value,
      };

      return api.transactions.getTransactionsReportRequest.perform(wlSlug, requestPayload)
        .then((data) => {
          downloadFile(
            `transactions-report-${dayjs().format('YYYY-MM-DD HH:mm:ss')}.csv`,
            'data:text/csv;charset=UTF-8,' + encodeURIComponent(data.fileData),
          );
        })
        .catch((error) => {
          showErrorNotification(error);
        })
        .finally(() => {
          this.setTransactionListReportLoading(false);
        });
    },
  },
});
